import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FieldsService {

  constructor(private http: HttpClient) { }

  getFields(): Observable<any[]>{ 
    let url = `${environment.url}/crm/field`;
    return this.http.get<any[]>(url);
  }
}
